import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';
import { CompanyUser } from '../users/users.model';

import { CompanyResponseModel } from './company.model';

@Injectable()
export class CompanyApi {
  constructor(private clientService: ClientService) {}

  /**
   * Gets Company's clients
   * @param companyNumber
   */
  getCompanyClients(companyNumber: string): Observable<CompanyUser[]> {
    const endpoint = `users/v1/companies/${companyNumber}/users`;

    return this.clientService.get(endpoint);
  }

  /**
   * Get company based on customer number.
   * @param customerNumber
   */
  getUserCompany(customerNumber: string): Observable<CompanyResponseModel> {
    const endpoint = `company/v3/companies/${customerNumber}`;

    return this.clientService.get(endpoint);
  }
}
